export const Data = [
  {
    products: [
      {
        id: 0,
        imgSrc: `/assets/images/pd-1.svg`,
      },
      {
        id: 1,
        imgSrc: `/assets/images/pd-2.svg`,
      },
      {
        id: 2,
        imgSrc: `/assets/images/pd-3.svg`,
      },
      {
        id: 3,
        imgSrc: `/assets/images/pd-4.svg`,
      },
    ],
  },
];
